module.exports = __webpack_public_path__ + "img/erp.8922bb11.jpg";